import { FormattedMessage } from "react-intl";
const ExternalCollaboration = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyOne"
                    defaultMessage="Invite external partners to collaborate as guests in your Confluence site. Guests are free of charge, up to 5 guests per paid user."
                />
            </p>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyTwo"
                    defaultMessage="You can also share view-only Confluence pages via public links. This can be useful for sharing information to the public, like customer FAQs and release notes."
                />
            </p>
        </div>
    );
};
export default ExternalCollaboration;
